import { isLocalTarget, normalizeTargetUrl } from '../browser/target-url';

/**
 * The product a visitor was sent to test: `?url=` on a link from floto.ai
 * (`/?url=https://theirproduct.com&utm_source=…`). Same rules as the link
 * field — normalised, and refused if it is not a link Floto can open from
 * the internet (localhost and friends).
 */
export function linkedTarget(params: URLSearchParams): string | null {
  const raw = params.get('url');
  if (!raw) return null;
  const normalized = normalizeTargetUrl(raw);
  if (!normalized || isLocalTarget(normalized)) return null;
  return normalized;
}

/**
 * The same, read out of a post-sign-in `redirect` ("/?url=…") — how /login
 * knows what the visitor is signing in to test.
 */
export function linkedTargetInRedirect(redirect: string): string | null {
  try {
    return linkedTarget(new URL(redirect, 'https://app.invalid').searchParams);
  } catch {
    return null;
  }
}

/** Where a session for `url` starts. */
export function browsePathFor(url: string): string {
  return `/browse?url=${encodeURIComponent(url)}`;
}
